/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/UnsplashImagesGrid.vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  id: "unsplashDrawer",
  class: "mt-8 h-full"
};
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center items-center text-2xl mt-24"
};
import useNodeClient from '@/composables/services/useNodeClient';
import { useUnsplashStore } from "@/stores/unsplash";
import { useConfiguratorStore } from "@/stores/configurator";
import { useImagesStore } from '@/stores/images';
import { useInfiniteScroll } from '@vueuse/core';
import { useCreateEditorImage } from "@/composables/2dEditor/useCreateEditorImage";
export default {
  __name: 'UnsplashImagesToolbar',
  setup(__props) {
    // import Adapter from '@/services/adapter'
    const Adapter = useNodeClient();
    const $eventBus = inject('bus');
    const el = ref(null);
    const configuratorStore = useConfiguratorStore();
    const imagesStore = useImagesStore();
    const {
      addUploadedImages
    } = imagesStore;
    const unsplashStore = useUnsplashStore();
    const {
      getUnsplashPictures,
      getUnsplashPicturesInfinite
    } = unsplashStore;
    const {
      closeDrawer
    } = configuratorStore;
    const {
      searchUnsplashQuery,
      unsplashPictures
    } = storeToRefs(unsplashStore);
    async function onHandleImage(image) {
      const uploadedImage = await Adapter.uploadUnsplashImage(image.urls.full);
      if (!uploadedImage) return;
      addUploadedImages([uploadedImage]);
      const originalUrl = uploadedImage?.url;
      const id = uploadedImage?._id;
      const url = uploadedImage?.versions?.find(({
        version
      }) => version === 'medium')?.url || originalUrl;
      const payload = {
        src: url,
        id,
        originalSource: originalUrl
      };
      const obj = await useCreateEditorImage(payload);
      $eventBus.$emit("object-added-new", obj);
      closeDrawer();
    }
    useInfiniteScroll(el, () => {
      // load more
      getUnsplashPicturesInfinite();
    }, {
      distance: 30
    });
    // const currentPage = ref(1);

    return (_ctx, _cache) => {
      const _component_UnsplashImagesGrid = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(searchUnsplashQuery) ? searchUnsplashQuery.value = $event : null),
        type: "text",
        placeholder: "Search",
        class: "input input-bordered w-full",
        onInput: _cache[1] || (_cache[1] = (...args) => _unref(getUnsplashPictures) && _unref(getUnsplashPictures)(...args))
      }, null, 544), [[_vModelText, _unref(searchUnsplashQuery)]]), _unref(unsplashPictures)?.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "el",
        ref: el,
        class: "overflow-y-auto mt-6"
      }, [_createVNode(_component_UnsplashImagesGrid, {
        pictures: _unref(unsplashPictures),
        "get-unsplash-pictures": _unref(getUnsplashPicturesInfinite),
        class: "h-[calc(100vh-240px)]",
        onHandleImage: onHandleImage
      }, null, 8, ["pictures", "get-unsplash-pictures"])], 512)) : _createCommentVNode("", true), !_unref(unsplashPictures)?.length && _unref(searchUnsplashQuery) === '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('configurator.searchResults')), 1)) : _createCommentVNode("", true)]);
    };
  }
};